<template>
	<div class="basis-cls">
		<section class="cell">
			<span class="title">文章反馈提醒</span>
			<div class="content">
				<svg-icon icon-class="NoAgree" />
				<span>无帮助 反馈达到</span>
				<el-input-number v-model="noHelpNum" @change="setEntity" :min="3" size="mini" :step-strictly="true"></el-input-number>
				<span>，管理员收到推送提醒。</span>
			</div>
		</section>
		<el-divider></el-divider>
		<section class="cell">
			<span class="title">审核过期时间</span>
			<div class="content">
				<span>知识审核 <small>未处理 </small>达到</span>
				<el-input-number v-model="taskExpireTime" @change="setEntity" :min="1" size="mini" :step-strictly="true"></el-input-number>
				<span>天，默认不通过。</span>
			</div>
		</section>
		<el-divider></el-divider>
		<section class="cell">
			<span class="title">删除库</span>
			<div class="content">
				<div class="item">
					<p>删除权限只有库管理员拥有。<span>注意！删除库后，你将丢失该库中的所有数据</span></p>
					<el-button @click.stop="innerVisible = true" type="danger" size="mini">删 除</el-button>
				</div>
			</div>
		</section>
		<el-dialog
			width="540px"
			title="删除确认"
			 :modal-append-to-body="false"
			:visible.sync="innerVisible"
			:close-on-press-escape="false" 
			:close-on-click-modal="false"
			append-to-body>
			<div style="text-align: right;">
				<p class="text">{{`你现在的操作是删除 “${row.name}”，一旦操作成功，团队下的所有内容将会删除。请输入下面内容再次确认操作。`}}</p>
				<span class="tip">{{`请在下方输入框中输入 "${row.name}" 以确认操作`}}</span>
				<el-input v-model="name" :placeholder="row.name" clearable></el-input>
				<el-button @click.stop="innerVisible = false;" size="mini">取 消</el-button>
				<el-button @click.stop="handleDelete" :disabled="row.name != name" type="primary" size="mini">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	props: ['row'],
	computed: {
		...mapGetters([
			'userInfo',
		])
	},
	data() {
		return {
			name: '',
			innerVisible: false,
			noHelpNum: 0,
			taskExpireTime: 0,
			list: []
		}
	},
	async created() {
		await this.getEntity();
	},
	methods: {
		handleDelete() {
			this.$api.apiPostKnowledgeDeleteResourceEntity({
				projectId: this.row.projectId,
				id: this.row.id
			}).then(response => {
				if(response.errcode != 0) return;
				this.innerVisible = false;
				this.$emit('closeEmitChange');
			});
		},
		getEntity() {
			this.$api.apiPostKnowledgeProjectGetEntity({
				id: this.userInfo.brandIdentify
			}).then(response => {
				if(response.errcode != 0) return;
				this.noHelpNum = response.data.noHelpNum;
				this.taskExpireTime = response.data.taskExpireTime / 24;
			});
		},
		setEntity() {
			this.$api.apiPostKnowledgeProjectSetEntity({
				id: this.userInfo.brandIdentify,
				noHelpNum: this.noHelpNum,
				taskExpireTime: this.taskExpireTime * 24
			}).then(response => {
				if(response.errcode != 0) return;
			});
		}
	}
}
</script>

<style lang="scss" scoped>
.basis-cls {
	width: 100%;
	height: calc(100vh - 135px);
	overflow-x: hidden;
	overflow-y: auto;

	& > .cell {
		width: 100%;
		margin-bottom: 35px;

		& > .title {
			font-size: 14px;
			font-weight: 500;
			color: #23335C;
			line-height: 20px;
			margin-bottom: 10px;
		}

		& > .content {
			box-sizing: border-box;
			& > .svg-icon {
				color: #fd504d;
				font-size: 12px;
			}

			& > span {
				font-size: 12px;
				font-weight: 400;
				color: #566980;
				line-height: 18px;
				margin: 0 2px;

				& > small {
					color: #fd504d;
				}
			}

			& > .item {
				& > p {
					font-size: 12px;
					font-weight: 400;
					color: #566980;
					line-height: 18px;
					margin-bottom: 20px;
				}
			}
		}
	}
}
.text {
	font-size: 14px;
	font-weight: 400;
	color: #838A9D;
	line-height: 22px;
	margin-bottom: 10px;
	text-align: left;
}

.tip {
	display: block;
	width: 100%;
	font-size: 14px;
	font-weight: 400;
	color: #3C4353;
	line-height: 22px;
	margin-bottom: 10px;
	text-align: left;
}

.el-input {
	margin: 10px 0;
}
</style>